import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDetails, PolicyService } from '@horizon/core';
import { UserSimplified } from '@horizon/core';
import { UrlBuilder } from 'http-url-builder';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MonitorAccessApiService {
  private readonly SESSION_KEY_DETAILS = 'usersDetailsList';
  public baseUrl: UrlBuilder = new UrlBuilder(environment.apim.baseUrl).addPath(
    environment.apim.apiSlugs.accessMonitorApi
  );
  public activeUsers$ = new BehaviorSubject<UserSimplified[]>([]);
  public allUsers$ = new BehaviorSubject<UserSimplified[]>([]);
  public usersDetailsSubject = new BehaviorSubject<UserDetails[]>([]);
  public usersDetails$ = this.usersDetailsSubject.asObservable();

  constructor(private http: HttpClient, private policyService: PolicyService) {}

  public monitorUser(entityId: number): Observable<any> {
    const fullUrl: string = this.baseUrl
      .addPath('api')
      .addPath('access')
      .addPath(entityId?.toString())
      .build();
    return this.http.post<any>(fullUrl, {});
  }

  public setActiveUsers(value: UserSimplified[]): void {
    this.activeUsers$.next(value);
  }

  public getActiveUsers(): any {
    return this.activeUsers$.getValue();
  }

  public getActiveUsersChanges(): Observable<any> {
    return this.activeUsers$.asObservable();
  }

  public setAllUsers(value: UserSimplified[]): void {
    this.allUsers$.next(value);
  }

  public getAllUsers(): any {
    return this.allUsers$.getValue();
  }

  public getAllUsersChanges(): Observable<any> {
    return this.allUsers$.asObservable();
  }

  public initUsersDetails(): void {
    const storedUsersDetails = sessionStorage.getItem(this.SESSION_KEY_DETAILS);
    if (storedUsersDetails) {
      try {
        const usersDetails: UserDetails[] = JSON.parse(storedUsersDetails);
        this.usersDetailsSubject.next(usersDetails);
      } catch (error) {
        console.error('Error parsing the users details from the store', error);
        this.fetchUsersDetailsFromAPI();
      }
    } else {
      this.fetchUsersDetailsFromAPI();
    }
  }

  private fetchUsersDetailsFromAPI(): void {
    this.policyService.getAllUsersDetails().subscribe({
      next: (usersDetails: UserDetails[]) => {
        this.usersDetailsSubject.next(usersDetails);
        sessionStorage.setItem(
          this.SESSION_KEY_DETAILS,
          JSON.stringify(usersDetails)
        );
      },
      error: (error) => {
        console.error('Error trying to get users details from the db', error);
      },
    });
  }
}
